// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Images */
.element-image {
    width: 100%;
    object-fit: contain;
    margin: 0 auto 0;
}

.element-image.large {
    width: 200px;
    height: 150px;
    margin: 20px auto;
}

/* Graph */
.element-graph {
    width: 100%;
    margin: 20px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 300px;
}

/* Typography */
.element-h1 {
    font-size: 26px;
    font-weight: 700;
    text-align: center;
    line-height: 1.3;
    margin-bottom: 32px;
}

.element-h2 {
    font-size: 20px;
    font-weight: 900;
    text-align: center;
    line-height: 1.4;
    margin-bottom: 20px;
}

.element-h3 {
    font-size: 16px;
    font-weight: 400;
    text-align: center;
    line-height: 1.4;
    margin-bottom: 20px;
}

.element-p {
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    line-height: 1.5;
    color: #999999;
    margin-bottom: 16px;
}

/* Icon Text */
.element-icon-text {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.5;
    color: #999999;
}

.icon-text-image {
    flex-shrink: 0;
    margin-top: 2px;
}

.icon-text-content {
    flex: 1;
}

/* Typing text */
.element-typing-text {
    font-size: 26px;
    font-weight: 700;
    text-align: center;
    line-height: 1.3;
    color: #ffffff;
    min-height: 1.3em;
}

.typing-text-content {
    display: inline;
    white-space: pre-wrap;
}

.typing-cursor {
    display: inline-block;
    animation: blink 1s infinite;
    margin-left: 2px;
    font-weight: 400;
}

/* Single choice */
.single-choice-container {
    margin: 5px 0;
}

.choice-option {
    width: 100%;
    padding: 18px 24px;
    margin-bottom: 12px;
    background-color: transparent;
    border: 2px solid #aaa;
    border-radius: 16px;
    color: #ffffff;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    text-align: left;
}

.choice-option.selected {
    background-color: #A145B080;
    border-color: #aaa;
}

.choice-option:last-child {
    margin-bottom: 0;
}

/* Grid choice */
.grid-choice-container {
    margin: 5px 0;
}

.grid-choice-card {
    display: flex;
    flex-direction: column;
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    border: 2px solid transparent;
    cursor: pointer;
    transition: all 0.2s ease;
    padding: 0;
    text-align: left;
}

.grid-choice-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.grid-choice-card.selected {
    border-color: #A145B0;
    box-shadow: 0 0 0 2px rgba(161, 69, 176, 0.5);
}

.grid-choice-image {
    aspect-ratio: 1;
    background: #eee;
    overflow: hidden;
}

.grid-choice-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.grid-choice-placeholder {
    width: 100%;
    height: 100%;
    min-height: 80px;
    background: #ddd;
}

.grid-choice-button {
    padding: 10px 12px;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: none;
    width: 100%;
}

.grid-choice-symbol {
    opacity: 0.9;
}

/* Horizontal single choice */
.horizontal-single-choice-container {
    margin: 5px 0;
    display: flex;
    justify-content: center;
}

.horizontal-single-choice-wrapper {
    width: fit-content;
    display: flex;
    flex-direction: column;
    align-items: stretch;
}

.horizontal-single-choice-row {
    display: flex;
    flex-wrap: wrap;
}

.horizontal-single-choice-item {
    padding: 12px 16px;
    border-radius: 12px;
    min-width: 44px;
    min-height: 44px;
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    border: 2px solid transparent;
    display: flex;
    align-items: center;
    justify-content: center;
}

.horizontal-single-choice-item:hover {
    transform: scale(1.05);
    opacity: 0.95;
}

.horizontal-single-choice-item.selected {
    box-shadow: 0 0 0 2px rgba(161, 69, 176, 0.5);
}

.horizontal-single-choice-item.full-width {
    flex: 1;
}

.horizontal-single-choice-item img {
    width: 36px;
    height: 36px;
    object-fit: cover;
    border-radius: 4px;
}

.horizontal-single-choice-descriptions {
    display: flex;
    justify-content: space-between;
    margin-top: 8px;
    font-size: 12px;
    color: #888;
}

/* Markdown */
.element-markdown {
    font-size: 14px;
    line-height: 1.5;
    text-align: center;
    margin: 20px 0;
}

.element-markdown a {
    color: #A145B0;
    text-decoration: none;
}

.element-markdown a:hover {
    text-decoration: underline;
}

.element-markdown strong {
    font-weight: 700;
}

/* Buttons */
.element-button,
.next-button {
    width: 100%;
    padding: 18px 24px;
    background: linear-gradient(135deg, #A145B0, #A145B0);
    border: none;
    border-radius: 12px;
    color: #ffffff;
    font-size: 18px;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.2s ease;
    margin-top: auto;
}

.element-button:hover,
.next-button:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(139, 92, 246, 0.3);
}

.element-button:disabled,
.next-button:disabled {
    opacity: 0.8;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
}

.element-button.secondary {
    background: #111;
    color: #A1A1A1;
}

.element-button.secondary:hover {
    background: #2A2A2A;
    color: #FFFFFF;
    border-color: rgba(255, 255, 255, 0.2);
}

.element-button.loading {
    position: relative;
    pointer-events: none;
}

.button-spinner {
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.button-spinner svg {
    animation: button-spinner-rotate 1.5s linear infinite;
}

/* Loading Bars */
.element-loading-bars {
    width: 100%;
    margin: 20px 0px;
}

.loading-bar-wrapper {
    margin-bottom: 4px;
}

.loading-bar-wrapper:last-child {
    margin-bottom: 0;
}

.loading-bar-top-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4px;
}

.loading-bar-label {
    font-size: 14px;
    font-weight: 500;
    color: #ffffff;
    text-align: left;
    flex: 1;
}

.loading-bar-right-side {
    display: flex;
    align-items: center;
    gap: 8px;
}

.loading-bar-percentage {
    font-size: 18px;
    font-weight: 600;
    color: #ffffff;
    min-width: 45px;
    text-align: right;
}

.loading-bar-spinner {
    width: 20px;
    height: 20px;
    border: 3px solid #333;
    border-top-color: #ffffff;
    border-radius: 50%;
    animation: spinner-rotate 0.8s linear infinite;
    display: none;
}

.loading-bar-container {
    width: 100%;
    height: 6px;
    background-color: #333;
    border-radius: 3px;
    overflow: hidden;
}

.loading-bar {
    height: 100%;
    width: 0%;
    border-radius: 3px;
    transition: width 2s ease-out;
}

/* Options */
.element-options {
    width: 60%;
    margin: 10px 0;
    display: flex;
    flex-direction: column;
    gap: 14px;
    margin-left: auto;
    margin-right: auto;
}

.option-item {
    display: flex;
    align-items: center;
    gap: 16px;
}

.option-icon {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: #A145B0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-weight: 800;
    font-size: 10px;
    flex-shrink: 0;
    font-family: Montserrat, system-ui, -apple-system, "system-ui", "Segoe UI", Roboto, "Helvetica Neue", sans-serif
}

.option-text {
    font-size: 14px;
    font-weight: 600;
    color: #ffffff;
}

/* List With Icons */
.element-list-with-icons {
    width: 60%;
    margin: 10px 0;
    display: flex;
    flex-direction: column;
    gap: 14px;
    margin-left: auto;
    margin-right: auto;
}

.list-with-icons-item {
    display: flex;
    align-items: center;
    gap: 16px;
}

.list-with-icons-icon {
    flex-shrink: 0;
    font-size: 20px;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* Email Input */
.element-email-input-container {
    width: 100%;
    margin: 20px 0;
}

.element-email-input {
    width: 100%;
    padding: 10px 14px;
    background-color: #ffffff;
    border: 3px solid #ffffff;
    border-radius: 15px;
    color: #999999;
    font-size: 18px;
    font-weight: 500;
    outline: none;
    transition: all 0.3s ease;
}

.element-email-input::placeholder {
    color: #999999;
}

.element-email-input:focus {
    border-color: #A145B0;
    color: #000000;
}

.element-email-input.error {
    border-color: #ff6b6b;
}

.element-email-input.error:focus {
    border-color: #ff6b6b;
}

/* Floating Timer */
.element-floating-timer {
    width: 100%;
    padding: 10px 20px;
    background-color: rgb(241, 139, 95);
    border-radius: 8px;
    margin: 0 0 20px 0;
    transition: all 0.3s ease;
    z-index: 100;
}

.element-floating-timer.sticky {
    position: fixed;
    top: 20px;
    max-width: 400px;
    margin: 0;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.floating-timer-text {
    font-size: 14px;
    font-weight: 700;
    text-align: center;
    line-height: 1.3;
    color: inherit;
}

/* Reviews Horizontal */
.element-reviews-horizontal {
    width: 100%;
    margin: 20px 0;
    overflow: hidden;
}

.reviews-scroll-wrapper {
    display: flex;
    gap: 16px;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
    padding: 4px;
    scroll-behavior: smooth;
}

.reviews-scroll-wrapper::-webkit-scrollbar {
    display: none;
}

.review-card {
    flex: 0 0 95%;
    background-color: #1a1a1a;
    border: none;
    border-radius: 12px;
    padding: 20px;
    scroll-snap-align: start;
    display: flex;
    flex-direction: column;
    gap: 14px;
}

/* Trustpilot-style stars */
.review-tp-stars {
    display: flex;
    gap: 3px;
}

.review-tp-star {
    width: 20px;
    height: 20px;
    background-color: #3a3a3a;
    display: flex;
    align-items: center;
    justify-content: center;
}

.review-tp-star.filled {
    background-color: #00B67A;
}

.review-tp-star svg {
    width: 18px;
    height: 18px;
    display: block;
}

.review-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
}

.review-title {
    font-size: 17px;
    font-weight: 700;
    color: #ffffff;
    line-height: 1.3;
    text-align: left;
}

.review-text {
    font-size: 15px;
    font-weight: 400;
    color: #e0e0e0;
    line-height: 1.5;
    text-align: left;
    flex: 1;
}

.review-name {
    font-size: 13px;
    font-weight: 600;
    color: #999999;
    white-space: nowrap;
}

/* Reviews Vertical */
.element-reviews-vertical {
    width: 100%;
    margin: 20px 0;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.review-vertical-card {
    background-color: #1A1A1A;
    border: none;
    border-radius: 12px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.review-vertical-title {
    font-size: 17px;
    font-weight: 700;
    color: #FFFFFF;
    text-align: left;
    line-height: 1.3;
}

.review-vertical-text {
    font-size: 15px;
    font-weight: 400;
    color: #e0e0e0;
    text-align: left;
    line-height: 1.5;
}

.review-vertical-author {
    font-size: 13px;
    font-weight: 600;
    color: #999999;
    text-align: left;
    white-space: nowrap;
}

/* List */
.element-list {
    width: 100%;
    margin: 20px 0;
}

.element-list-ol {
    list-style: none;
    counter-reset: list-counter;
    padding: 0;
    margin: 0;
}

.element-list-ol .element-list-item {
    counter-increment: list-counter;
    position: relative;
    padding-left: 32px;
    margin-bottom: 16px;
    font-size: 15px;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 1.5;
}

.element-list-ol .element-list-item::before {
    content: counter(list-counter) ".";
    position: absolute;
    left: 0;
    top: 0;
    color: #A145B0;
    font-weight: 700;
}

.element-list-ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.element-list-ul .element-list-item {
    position: relative;
    padding-left: 24px;
    margin-bottom: 16px;
    font-size: 15px;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 1.5;
}

.element-list-ul .element-list-item::before {
    content: "•";
    position: absolute;
    left: 0;
    top: 0;
    color: #A145B0;
    font-weight: 700;
    font-size: 18px;
}

/* Special Offer */
.element-special-offer {
    width: 100%;
    margin: 20px 0;
}

.special-offer-card {
    position: relative;
    width: 100%;
}

.special-offer-badge-container {
    position: absolute;
    top: -10px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
}

.special-offer-badge {
    background-color: #A145B0;
    color: #ffffff;
    font-size: 14px;
    font-weight: 700;
    padding: 4px 12px;
    border-radius: 6px;
}

.special-offer-button {
    width: 100%;
    background-color: #1A1A1A;
    border: 2px solid #A145B0;
    border-radius: 12px;
    padding: 18px;
    cursor: pointer;
    transition: all 0.3s ease;
}

.special-offer-button:hover {
    transform: scale(1.02);
}

.special-offer-body {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
}

.special-offer-details {
    flex: 1;
    text-align: left;
}

.special-offer-title {
    font-size: 16px;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 8px;
}

.special-offer-prices {
    display: flex;
    align-items: center;
    gap: 8px;
}

.special-offer-old-price {
    font-size: 16px;
    font-weight: 500;
    color: #7A7A7A;
    text-decoration: line-through;
}

.special-offer-price-block {
    position: relative;
    width: 104px;
    height: 46px;
    flex-shrink: 0;
}

.special-offer-price-shape {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    color: #A145B0;
}

.special-offer-price-content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 12px;
}

.special-offer-price-wrap {
    display: flex;
    align-items: center;
    gap: 4px;
}

.special-offer-currency {
    font-size: 16px;
    font-weight: 700;
    color: #ffffff;
    line-height: 1;
}

.special-offer-int-digits {
    font-size: 36px;
    font-weight: 700;
    color: #ffffff;
    line-height: 1;
}

.special-offer-fraction-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
}

.special-offer-fraction-digits {
    font-size: 14px;
    font-weight: 700;
    color: #ffffff;
    line-height: 1;
}
`, "",{"version":3,"sources":["webpack://./src/styles/elements.css"],"names":[],"mappings":"AAAA,WAAW;AACX;IACI,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;AACrB;;AAEA,UAAU;AACV;IACI,WAAW;IACX,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA,eAAe;AACf;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA,cAAc;AACd;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,OAAO;AACX;;AAEA,gBAAgB;AAChB;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,kBAAkB;AAClB;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;IAC7B,sBAAsB;IACtB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,gBAAgB;AAChB;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,yCAAyC;IACzC,6BAA6B;IAC7B,eAAe;IACf,yBAAyB;IACzB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA,6BAA6B;AAC7B;IACI,aAAa;IACb,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,eAAe;IACf,WAAW;AACf;;AAEA,aAAa;AACb;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA,YAAY;AACZ;;IAEI,WAAW;IACX,kBAAkB;IAClB,qDAAqD;IACrD,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;;IAEI,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;;IAEI,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,qDAAqD;AACzD;;AAEA,iBAAiB;AACjB;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,OAAO;AACX;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,8CAA8C;IAC9C,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA,YAAY;AACZ;IACI,UAAU;IACV,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA,oBAAoB;AACpB;IACI,UAAU;IACV,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA,gBAAgB;AAChB;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA,mBAAmB;AACnB;IACI,WAAW;IACX,kBAAkB;IAClB,mCAAmC;IACnC,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,SAAS;IACT,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA,uBAAuB;AACvB;IACI,WAAW;IACX,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,6BAA6B;IAC7B,iCAAiC;IACjC,qBAAqB;IACrB,wBAAwB;IACxB,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,wBAAwB;IACxB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA,2BAA2B;AAC3B;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,OAAO;AACX;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA,qBAAqB;AACrB;IACI,WAAW;IACX,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,SAAS;AACT;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,UAAU;IACV,SAAS;AACb;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA,kBAAkB;AAClB;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,OAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,MAAM;AACV;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,cAAc;AAClB","sourcesContent":["/* Images */\n.element-image {\n    width: 100%;\n    object-fit: contain;\n    margin: 0 auto 0;\n}\n\n.element-image.large {\n    width: 200px;\n    height: 150px;\n    margin: 20px auto;\n}\n\n/* Graph */\n.element-graph {\n    width: 100%;\n    margin: 20px 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 300px;\n}\n\n/* Typography */\n.element-h1 {\n    font-size: 26px;\n    font-weight: 700;\n    text-align: center;\n    line-height: 1.3;\n    margin-bottom: 32px;\n}\n\n.element-h2 {\n    font-size: 20px;\n    font-weight: 900;\n    text-align: center;\n    line-height: 1.4;\n    margin-bottom: 20px;\n}\n\n.element-h3 {\n    font-size: 16px;\n    font-weight: 400;\n    text-align: center;\n    line-height: 1.4;\n    margin-bottom: 20px;\n}\n\n.element-p {\n    font-size: 14px;\n    font-weight: 400;\n    text-align: center;\n    line-height: 1.5;\n    color: #999999;\n    margin-bottom: 16px;\n}\n\n/* Icon Text */\n.element-icon-text {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 1.5;\n    color: #999999;\n}\n\n.icon-text-image {\n    flex-shrink: 0;\n    margin-top: 2px;\n}\n\n.icon-text-content {\n    flex: 1;\n}\n\n/* Typing text */\n.element-typing-text {\n    font-size: 26px;\n    font-weight: 700;\n    text-align: center;\n    line-height: 1.3;\n    color: #ffffff;\n    min-height: 1.3em;\n}\n\n.typing-text-content {\n    display: inline;\n    white-space: pre-wrap;\n}\n\n.typing-cursor {\n    display: inline-block;\n    animation: blink 1s infinite;\n    margin-left: 2px;\n    font-weight: 400;\n}\n\n/* Single choice */\n.single-choice-container {\n    margin: 5px 0;\n}\n\n.choice-option {\n    width: 100%;\n    padding: 18px 24px;\n    margin-bottom: 12px;\n    background-color: transparent;\n    border: 2px solid #aaa;\n    border-radius: 16px;\n    color: #ffffff;\n    font-size: 16px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    text-align: left;\n}\n\n.choice-option.selected {\n    background-color: #A145B080;\n    border-color: #aaa;\n}\n\n.choice-option:last-child {\n    margin-bottom: 0;\n}\n\n/* Grid choice */\n.grid-choice-container {\n    margin: 5px 0;\n}\n\n.grid-choice-card {\n    display: flex;\n    flex-direction: column;\n    background: #fff;\n    border-radius: 12px;\n    overflow: hidden;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n    border: 2px solid transparent;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    padding: 0;\n    text-align: left;\n}\n\n.grid-choice-card:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.grid-choice-card.selected {\n    border-color: #A145B0;\n    box-shadow: 0 0 0 2px rgba(161, 69, 176, 0.5);\n}\n\n.grid-choice-image {\n    aspect-ratio: 1;\n    background: #eee;\n    overflow: hidden;\n}\n\n.grid-choice-image img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.grid-choice-placeholder {\n    width: 100%;\n    height: 100%;\n    min-height: 80px;\n    background: #ddd;\n}\n\n.grid-choice-button {\n    padding: 10px 12px;\n    color: #fff;\n    font-size: 14px;\n    font-weight: 500;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border: none;\n    width: 100%;\n}\n\n.grid-choice-symbol {\n    opacity: 0.9;\n}\n\n/* Horizontal single choice */\n.horizontal-single-choice-container {\n    margin: 5px 0;\n    display: flex;\n    justify-content: center;\n}\n\n.horizontal-single-choice-wrapper {\n    width: fit-content;\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n}\n\n.horizontal-single-choice-row {\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.horizontal-single-choice-item {\n    padding: 12px 16px;\n    border-radius: 12px;\n    min-width: 44px;\n    min-height: 44px;\n    text-align: center;\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    border: 2px solid transparent;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.horizontal-single-choice-item:hover {\n    transform: scale(1.05);\n    opacity: 0.95;\n}\n\n.horizontal-single-choice-item.selected {\n    box-shadow: 0 0 0 2px rgba(161, 69, 176, 0.5);\n}\n\n.horizontal-single-choice-item.full-width {\n    flex: 1;\n}\n\n.horizontal-single-choice-item img {\n    width: 36px;\n    height: 36px;\n    object-fit: cover;\n    border-radius: 4px;\n}\n\n.horizontal-single-choice-descriptions {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 8px;\n    font-size: 12px;\n    color: #888;\n}\n\n/* Markdown */\n.element-markdown {\n    font-size: 14px;\n    line-height: 1.5;\n    text-align: center;\n    margin: 20px 0;\n}\n\n.element-markdown a {\n    color: #A145B0;\n    text-decoration: none;\n}\n\n.element-markdown a:hover {\n    text-decoration: underline;\n}\n\n.element-markdown strong {\n    font-weight: 700;\n}\n\n/* Buttons */\n.element-button,\n.next-button {\n    width: 100%;\n    padding: 18px 24px;\n    background: linear-gradient(135deg, #A145B0, #A145B0);\n    border: none;\n    border-radius: 12px;\n    color: #ffffff;\n    font-size: 18px;\n    font-weight: 700;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    margin-top: auto;\n}\n\n.element-button:hover,\n.next-button:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(139, 92, 246, 0.3);\n}\n\n.element-button:disabled,\n.next-button:disabled {\n    opacity: 0.8;\n    cursor: not-allowed;\n    transform: none;\n    box-shadow: none;\n}\n\n.element-button.secondary {\n    background: #111;\n    color: #A1A1A1;\n}\n\n.element-button.secondary:hover {\n    background: #2A2A2A;\n    color: #FFFFFF;\n    border-color: rgba(255, 255, 255, 0.2);\n}\n\n.element-button.loading {\n    position: relative;\n    pointer-events: none;\n}\n\n.button-spinner {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.button-spinner svg {\n    animation: button-spinner-rotate 1.5s linear infinite;\n}\n\n/* Loading Bars */\n.element-loading-bars {\n    width: 100%;\n    margin: 20px 0px;\n}\n\n.loading-bar-wrapper {\n    margin-bottom: 4px;\n}\n\n.loading-bar-wrapper:last-child {\n    margin-bottom: 0;\n}\n\n.loading-bar-top-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 4px;\n}\n\n.loading-bar-label {\n    font-size: 14px;\n    font-weight: 500;\n    color: #ffffff;\n    text-align: left;\n    flex: 1;\n}\n\n.loading-bar-right-side {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.loading-bar-percentage {\n    font-size: 18px;\n    font-weight: 600;\n    color: #ffffff;\n    min-width: 45px;\n    text-align: right;\n}\n\n.loading-bar-spinner {\n    width: 20px;\n    height: 20px;\n    border: 3px solid #333;\n    border-top-color: #ffffff;\n    border-radius: 50%;\n    animation: spinner-rotate 0.8s linear infinite;\n    display: none;\n}\n\n.loading-bar-container {\n    width: 100%;\n    height: 6px;\n    background-color: #333;\n    border-radius: 3px;\n    overflow: hidden;\n}\n\n.loading-bar {\n    height: 100%;\n    width: 0%;\n    border-radius: 3px;\n    transition: width 2s ease-out;\n}\n\n/* Options */\n.element-options {\n    width: 60%;\n    margin: 10px 0;\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.option-item {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n}\n\n.option-icon {\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    background-color: #A145B0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #ffffff;\n    font-weight: 800;\n    font-size: 10px;\n    flex-shrink: 0;\n    font-family: Montserrat, system-ui, -apple-system, \"system-ui\", \"Segoe UI\", Roboto, \"Helvetica Neue\", sans-serif\n}\n\n.option-text {\n    font-size: 14px;\n    font-weight: 600;\n    color: #ffffff;\n}\n\n/* List With Icons */\n.element-list-with-icons {\n    width: 60%;\n    margin: 10px 0;\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.list-with-icons-item {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n}\n\n.list-with-icons-icon {\n    flex-shrink: 0;\n    font-size: 20px;\n    line-height: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n/* Email Input */\n.element-email-input-container {\n    width: 100%;\n    margin: 20px 0;\n}\n\n.element-email-input {\n    width: 100%;\n    padding: 10px 14px;\n    background-color: #ffffff;\n    border: 3px solid #ffffff;\n    border-radius: 15px;\n    color: #999999;\n    font-size: 18px;\n    font-weight: 500;\n    outline: none;\n    transition: all 0.3s ease;\n}\n\n.element-email-input::placeholder {\n    color: #999999;\n}\n\n.element-email-input:focus {\n    border-color: #A145B0;\n    color: #000000;\n}\n\n.element-email-input.error {\n    border-color: #ff6b6b;\n}\n\n.element-email-input.error:focus {\n    border-color: #ff6b6b;\n}\n\n/* Floating Timer */\n.element-floating-timer {\n    width: 100%;\n    padding: 10px 20px;\n    background-color: rgb(241, 139, 95);\n    border-radius: 8px;\n    margin: 0 0 20px 0;\n    transition: all 0.3s ease;\n    z-index: 100;\n}\n\n.element-floating-timer.sticky {\n    position: fixed;\n    top: 20px;\n    max-width: 400px;\n    margin: 0;\n    border-radius: 12px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n}\n\n.floating-timer-text {\n    font-size: 14px;\n    font-weight: 700;\n    text-align: center;\n    line-height: 1.3;\n    color: inherit;\n}\n\n/* Reviews Horizontal */\n.element-reviews-horizontal {\n    width: 100%;\n    margin: 20px 0;\n    overflow: hidden;\n}\n\n.reviews-scroll-wrapper {\n    display: flex;\n    gap: 16px;\n    overflow-x: auto;\n    scroll-snap-type: x mandatory;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n    padding: 4px;\n    scroll-behavior: smooth;\n}\n\n.reviews-scroll-wrapper::-webkit-scrollbar {\n    display: none;\n}\n\n.review-card {\n    flex: 0 0 95%;\n    background-color: #1a1a1a;\n    border: none;\n    border-radius: 12px;\n    padding: 20px;\n    scroll-snap-align: start;\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n}\n\n/* Trustpilot-style stars */\n.review-tp-stars {\n    display: flex;\n    gap: 3px;\n}\n\n.review-tp-star {\n    width: 20px;\n    height: 20px;\n    background-color: #3a3a3a;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.review-tp-star.filled {\n    background-color: #00B67A;\n}\n\n.review-tp-star svg {\n    width: 18px;\n    height: 18px;\n    display: block;\n}\n\n.review-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n}\n\n.review-title {\n    font-size: 17px;\n    font-weight: 700;\n    color: #ffffff;\n    line-height: 1.3;\n    text-align: left;\n}\n\n.review-text {\n    font-size: 15px;\n    font-weight: 400;\n    color: #e0e0e0;\n    line-height: 1.5;\n    text-align: left;\n    flex: 1;\n}\n\n.review-name {\n    font-size: 13px;\n    font-weight: 600;\n    color: #999999;\n    white-space: nowrap;\n}\n\n/* Reviews Vertical */\n.element-reviews-vertical {\n    width: 100%;\n    margin: 20px 0;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.review-vertical-card {\n    background-color: #1A1A1A;\n    border: none;\n    border-radius: 12px;\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n}\n\n.review-vertical-title {\n    font-size: 17px;\n    font-weight: 700;\n    color: #FFFFFF;\n    text-align: left;\n    line-height: 1.3;\n}\n\n.review-vertical-text {\n    font-size: 15px;\n    font-weight: 400;\n    color: #e0e0e0;\n    text-align: left;\n    line-height: 1.5;\n}\n\n.review-vertical-author {\n    font-size: 13px;\n    font-weight: 600;\n    color: #999999;\n    text-align: left;\n    white-space: nowrap;\n}\n\n/* List */\n.element-list {\n    width: 100%;\n    margin: 20px 0;\n}\n\n.element-list-ol {\n    list-style: none;\n    counter-reset: list-counter;\n    padding: 0;\n    margin: 0;\n}\n\n.element-list-ol .element-list-item {\n    counter-increment: list-counter;\n    position: relative;\n    padding-left: 32px;\n    margin-bottom: 16px;\n    font-size: 15px;\n    font-weight: 600;\n    color: #FFFFFF;\n    line-height: 1.5;\n}\n\n.element-list-ol .element-list-item::before {\n    content: counter(list-counter) \".\";\n    position: absolute;\n    left: 0;\n    top: 0;\n    color: #A145B0;\n    font-weight: 700;\n}\n\n.element-list-ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n\n.element-list-ul .element-list-item {\n    position: relative;\n    padding-left: 24px;\n    margin-bottom: 16px;\n    font-size: 15px;\n    font-weight: 600;\n    color: #FFFFFF;\n    line-height: 1.5;\n}\n\n.element-list-ul .element-list-item::before {\n    content: \"•\";\n    position: absolute;\n    left: 0;\n    top: 0;\n    color: #A145B0;\n    font-weight: 700;\n    font-size: 18px;\n}\n\n/* Special Offer */\n.element-special-offer {\n    width: 100%;\n    margin: 20px 0;\n}\n\n.special-offer-card {\n    position: relative;\n    width: 100%;\n}\n\n.special-offer-badge-container {\n    position: absolute;\n    top: -10px;\n    left: 50%;\n    transform: translateX(-50%);\n    z-index: 10;\n}\n\n.special-offer-badge {\n    background-color: #A145B0;\n    color: #ffffff;\n    font-size: 14px;\n    font-weight: 700;\n    padding: 4px 12px;\n    border-radius: 6px;\n}\n\n.special-offer-button {\n    width: 100%;\n    background-color: #1A1A1A;\n    border: 2px solid #A145B0;\n    border-radius: 12px;\n    padding: 18px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n}\n\n.special-offer-button:hover {\n    transform: scale(1.02);\n}\n\n.special-offer-body {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 16px;\n}\n\n.special-offer-details {\n    flex: 1;\n    text-align: left;\n}\n\n.special-offer-title {\n    font-size: 16px;\n    font-weight: 700;\n    color: #ffffff;\n    margin-bottom: 8px;\n}\n\n.special-offer-prices {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.special-offer-old-price {\n    font-size: 16px;\n    font-weight: 500;\n    color: #7A7A7A;\n    text-decoration: line-through;\n}\n\n.special-offer-price-block {\n    position: relative;\n    width: 104px;\n    height: 46px;\n    flex-shrink: 0;\n}\n\n.special-offer-price-shape {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    color: #A145B0;\n}\n\n.special-offer-price-content {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding-left: 12px;\n}\n\n.special-offer-price-wrap {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.special-offer-currency {\n    font-size: 16px;\n    font-weight: 700;\n    color: #ffffff;\n    line-height: 1;\n}\n\n.special-offer-int-digits {\n    font-size: 36px;\n    font-weight: 700;\n    color: #ffffff;\n    line-height: 1;\n}\n\n.special-offer-fraction-container {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0;\n}\n\n.special-offer-fraction-digits {\n    font-size: 14px;\n    font-weight: 700;\n    color: #ffffff;\n    line-height: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
